<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">hematology</i>
                        </div>
                        <h6 class="mb-3" style="margin-left: 4.5rem !important;">{{ $t('testmatings.Testmatings') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>                               
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2">
                                <div class="btn-group" v-if="userRoleName === 'Keeper' ">
                                    <router-link
                                        :to="associationId ? { name: 'New Testmating', params: { id: associationId } } : ''"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 205px;"
                                    >
                                    {{ $t('testmatings.Generate_testmating') }}
                                    </router-link>
                                </div>
                                <div class="btn-group" v-if="userRoleName == 'Admin'">
                                    <router-link
                                        :to="associationId ? `/testmating/create/${associationId}` : '#'"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 205px;"
                                    >
                                        {{ $t('testmatings.Generate_testmating') }}
                                    </router-link>

                                    <!-- Dropdown toggle -->
                                    <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                    </button>

                                    <!-- Dropdown menu -->
                                    <ul class="dropdown-menu dropdown-menu-end  custom-association-dropdown">
                                        <li @click="associationId = ''">
                                            <span class="dropdown-item text-muted">
                                            {{ $t('settings.Select_association') }}
                                            </span>
                                        </li>
                                        <li><hr class="dropdown-divider" /></li>
                                        <li
                                            v-for="item in associations"
                                            :key="item.id"
                                            @click="associationId = item.id"
                                            class="dropdown-item"
                                        >
                                            {{ item.abbreviation }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">                                                
                        <table id="mating-list" class="table table-flush" v-if="tableVisible">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('testmatings.Testmating') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('testmatings.Created') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('testmatings.NoOfFathers') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('testmatings.NoOfMothers') }}</p></th>
                                    <th></th>                                    
                                </tr>
                            </thead>                            
                            <tbody>                                
                                <tr v-for="item in testmatings" :key="item.id">
                                    <td class="text-sm font-weight-normal">{{ item.keeperName }}
                                        <span v-if="['Admin'].includes(userRoleName)">
                                            <br><small><b>{{ $t('settings.Association') }}</b>: {{ item.associationName }}</small>
                                            <br><small><b>{{ $t('location.UBN') }}</b>: {{ item.ubn }}</small>
                                        </span>                                        
                                    </td>
                                    <td class="text-sm font-weight-normal">{{ formatDate(item.created) }}</td>                                    
                                    <td class="text-sm font-weight-normal">{{ item.noOfFathers }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.noOfMothers }}</td>
                                    <td>
                                        <div class="d-flex flex-wrap justify-content-end gap-2">
                                            <button :data-id="item.groupGuid" class="btn btn-sm bg-gradient-success report-button" :title="$t('common.Download')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">download</i>
                                            </button>
                                            <button :data-id="item.groupGuid" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">delete</i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>                                
                            </tbody>
                        </table>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Mating_index_page',
    components: {
    },
    data() {
        return {
            associationId: '',
            associations: [],
            testmatings: [],
            gets: [],            
            dataTableInstance: null,
            tableVisible: false,
            choicesInstanceAssociation: null
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);            
            await this.loadTestMatings();
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: {        
        async initDataTable() {

            await nextTick();

            const table = document.querySelector("#mating-list");
            if (!table || !table.parentNode) {
                console.warn("Table or its parent not found. Skipping DataTable init.");
                return;
            }

            if (this.dataTableInstance) {
                this.dataTableInstance.destroy();
                this.dataTableInstance = null;
            }

            this.dataTableInstance = new DataTable("#mating-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: true },
                    { select: 3, sortable: true },
                    { select: 4, sortable: false },                      
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });  

            table.addEventListener('click', this.handleTableClick);
        },  
        handleTableClick(event) {

            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            if (event.target.classList.contains('delete-button')) {                                                        
                this.deleteTestMatingModal(id);
            } else if (event.target.closest('.report-button')) {
                this.$router.push({ name: 'Report Testmating', params: { id } });
            }
        },
        async loadTestMatings() {
            try {

                let response;
                const role = this.$store.state.roleName;

                if (role === 'Admin') {
                    await this.fetchAllAssociationData();
                    response = await await axios.get("testmating/getall");
                } else if (role === 'AssociationAdmin') {
                    const associationId = this.$store.state.associationAdminAssociationId;
                    this.associationId = associationId;
                    response = await axios.get(`/testmating/getbyassociation?associationId=${associationId}`)
                } else if (role === 'Keeper') {
                    const ubnId = this.$store.state.keeperLocationId;
                    this.associationId = this.$store.state.keeperAssociationId;

                    response = await axios.get(`/testmating/getbyubn?ubnId=${ubnId}`)
                }

                this.gets = response.data;

                if (!this.gets?.success) {
                    this.$showError('errors.Contact_system_admin');
                    return;
                }

                const rawData = Array.isArray(this.gets.data) ? this.gets.data : [];

                // 1. Destroy DataTable if it exists
                if (this.dataTableInstance) {
                    this.dataTableInstance.destroy();
                    this.dataTableInstance = null;
                }

                // 2. Force table unmount
                this.tableVisible = false;

                // 3. Wait for DOM update to unmount table
                await this.$nextTick();

                // 4. Set matings data
                this.testmatings = rawData;

                // 5. Force table mount
                this.tableVisible = true;

                // 6. Wait for DOM update to mount table
                await this.$nextTick();

                // 7. Init DataTable if data is present
                if (rawData.length > 0) {
                    this.initDataTable();
                } else {
                    this.initDataTable();
                    this.$showSuccess('errors.No_test_matings_found');
                }

            } catch (e) {
                console.error("Exception occurred in loadTestMatings()", e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },        
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;
                } else {
                    this.$showError('errors.Error_fetching_associations');                    
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },        
        async deleteTestMatingModal(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("TestMating/group/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {

                                    let fetchResponse;
                                    const role = this.$store.state.roleName;

                                    if (role === 'Admin') {                                    
                                        fetchResponse = await await axios.get("testmating/getall");
                                    } else if (role === 'AssociationAdmin') {
                                        const associationId = this.$store.state.associationAdminAssociationId;
                                        this.associationId = associationId;

                                        fetchResponse = await axios.get(`/testmating/getbyassociation?associationId=${associationId}`)
                                    } else if (role === 'Keeper') {
                                        const ubnId = this.$store.state.keeperLocationId;
                                        this.associationId = this.$store.state.keeperAssociationId;

                                        fetchResponse = await axios.get(`/testmating/getbyubn?ubnId=${ubnId}`)
                                    }
                                    
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {
                                        this.testmatings = fetchResult.data;

                                        if (this.dataTableInstance && typeof this.dataTableInstance.rows === 'function') {                                            
                                            this.dataTableInstance.rows().remove();                                            
                                        } else {
                                            console.log('DataTable instance is not valid or not initialized');
                                        }

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');                                        
                                    } else {
                                        throw new Error('Failed to fetch updated testmating list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        }
    },
    computed: {        
        userRoleName() {
            return this.$store.state.user?.roleName;
        }
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }
</style>